import { FileText } from 'lucide-react';

export function DeclarationInfo() {
  return (
    <div className="bg-white dark:bg-accessible-gray-800 high-contrast:bg-black p-8 rounded-lg shadow-lg">
      <div className="flex items-center gap-4 mb-6">
        <div className="w-12 h-12 rounded-full bg-accessible-red-600/10 flex items-center justify-center">
          <FileText className="w-6 h-6 text-accessible-red-600" aria-hidden="true" />
        </div>
        <h2 className="card-title">
          Informacje o deklaracji
        </h2>
      </div>
      
      <div className="space-y-4">
        <p className="body-medium">
          <strong>EPKO sp. z o.o.</strong> zobowiązuje się zapewnić dostępność strony internetowej <strong>znajdki.pl</strong> zgodnie z ustawą z dnia 4 kwietnia 2019 r. o dostępności cyfrowej stron internetowych i aplikacji mobilnych podmiotów publicznych. Strona jest częściowo zgodna z ww. ustawą z powodu niezgodności lub wyłączeń wymienionych poniżej.
        </p>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
          <div className="bg-accessible-gray-50 dark:bg-accessible-gray-700 high-contrast:bg-black p-4 rounded-lg">
            <h3 className="label-large mb-1">
              Data ostatniej aktualizacji deklaracji
            </h3>
            <p className="body-medium no-margin">
              07 listopada 2025
            </p>
          </div>
          <div className="bg-accessible-gray-50 dark:bg-accessible-gray-700 high-contrast:bg-black p-4 rounded-lg">
            <h3 className="label-large mb-1">
              Data publikacji strony
            </h3>
            <p className="body-medium no-margin">27 wrzesień 2025</p>
          </div>
          <div>
            <div className="bg-accessible-gray-50 dark:bg-accessible-gray-700 high-contrast:bg-black p-4 rounded-lg">
              <h3 className="label-large mb-1">
                Data sporządzenia deklaracji
              </h3>
              <p className="body-medium no-margin">{new Date().toLocaleDateString('pl-PL')}</p>
            </div>
          </div>
        </div>
        <div className="mt-4">
          <h3 className="label-large mb-1">
            Metoda sporządzenia deklaracji
          </h3>
          <p className="body-medium no-margin">
            Samoocena przeprowadzona przez podmiot publiczny
          </p>
        </div>
      </div>
    </div>
  );
}